import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { InstagramIcon } from "@/components/InstagramIcon";
import { Loader2 } from "lucide-react";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";

const INTRO_CALL_URL = "https://calendar.app.google/deNa1YHwnMHHqxL89";

export function OnboardingInstagramRoute() {
  const { clearBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    clearBreadcrumbs();
  }, []);

  useEffect(() => {
    fetch("/api/ig-account")
      .then((res) => res.json())
      .then((data) => {
        if (data?.igAccount) {
          navigate("/instagram/fans", { replace: true });
        }
      })
      .catch(() => {})
      .finally(() => setIsChecking(false));
  }, [navigate]);

  if (isChecking) {
    return (
      <div className="container mx-auto p-8 flex flex-col items-center justify-center min-h-screen">
        <Loader2 className="animate-spin h-12 w-12 text-muted-foreground" />
      </div>
    );
  }

  const scope = "instagram_business_basic,instagram_business_manage_comments";
  const connectUrl = `/api/onboarding/instagram/connect?redirect=${encodeURIComponent(`${window.location.origin}/instagram/fans`)}&scope=${encodeURIComponent(scope)}`;

  return (
    <div className="container mx-auto flex min-h-screen flex-col items-center p-8">
      <div className="flex w-full max-w-lg flex-1 flex-col items-center justify-center gap-4">
        <Card className="w-full">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-pink-50">
              <InstagramIcon className="h-8 w-8 text-pink-600" />
            </div>
            <CardTitle className="text-2xl font-bold">Find your active fans</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-3 text-sm text-muted-foreground">
              <p>Engram will analyze comments on all your posts and show you your most active fans</p>
            </div>
            <Button asChild className="w-full" size="lg">
              <a href={connectUrl}>Connect Instagram account</a>
            </Button>
          </CardContent>
        </Card>
        <Card className="w-full">
          <CardHeader className="text-center">
            <img
              src="/assets/adam.png"
              alt="Adam"
              className="mx-auto mb-4 h-14 w-14 rounded-full object-cover"
            />
            <CardTitle className="text-2xl font-bold">Not Sure?</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <p className="text-center text-sm text-muted-foreground">
              Book a free intro call and I'll walk you through how Engram works.
            </p>
            <Button asChild className="w-full" size="lg" variant="outline">
              <a href={INTRO_CALL_URL} target="_blank" rel="noopener noreferrer">
                Book an intro call
              </a>
            </Button>
          </CardContent>
        </Card>
      </div>
      <footer className="flex flex-col items-center gap-1 py-6 text-center">
        <p className="text-xs text-muted-foreground">Engram (formerly Kaizen Place)</p>
        <p className="text-xs text-muted-foreground">
          <a
            href="mailto:hello@engram.sh"
            className="font-medium text-primary underline underline-offset-4"
          >
            Contact Us
          </a>
        </p>
      </footer>
    </div>
  );
}
